var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 572.32 572.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffead0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clear"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.62,51.24h225l3.31,33.08s-49.63,9.93-39.7,43c3.31,36.39,138.94,238.19,175.33,277.88s33.08,46.32,102.56,56.24l-6.62,56.24L290.89,521,271,461.45s49.62,6.62,56.24-9.92c0,0,9.92-13.23,0-36.39C329.15,416.57,195,170.33,142,127.33,129.18,116.9,59.31,94.25,59.31,94.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.31,517.69h225l13.24-52.93S195,474.69,204.87,441.6c3.31-36.39,195.19-228.26,231.58-268S469.53,127.33,539,117.4l-6.62-56.24-205.1-9.92L310.74,84.32s33.08,0,43,36.39c0,0,3.31,23.16-16.54,43,1.88-1.43-188.56,234.88-241.5,277.88C82.87,452,13,474.69,13,474.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearButton);
export default __webpack_public_path__ + "static/media/clear-button.4877210b8905149e3002998107041823.svg";
export { ForwardRef as ReactComponent };